import { render, staticRenderFns } from "./fhir-positive-int.vue?vue&type=template&id=68f40c8e&"
import script from "./fhir-positive-int.vue?vue&type=script&lang=js&"
export * from "./fhir-positive-int.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
